var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.07,
    height: 8.23,
    viewBox: "0 0 15.07 8.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #676767;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.58,6.59a1.59,1.59,0,0,1,.15-.21q3-3.06,6.1-6.1A.74.74,0,0,1,14.49,0a.68.68,0,0,1,.43,1.1,1.29,1.29,0,0,1-.16.17L8.13,7.91a.72.72,0,0,1-1.19,0L.28,1.25A.76.76,0,0,1,0,.56.69.69,0,0,1,1.11.15a1,1,0,0,1,.18.18L7.36,6.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.463298221766383a40a97adce50a14ef.svg";
export { ForwardRef as ReactComponent };